import { render, staticRenderFns } from "./SuperAdminNewClient.vue?vue&type=template&id=167e15c4&"
import script from "./SuperAdminNewClient.vue?vue&type=script&lang=js&"
export * from "./SuperAdminNewClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports